import {FIELD_TYPE} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
const {INPUT, SELECT, DATE, NUMBER, AUTO_COMPLETE, COMBO_BOX, CURRENCY, CODE} =
  FIELD_TYPE;
const columnsPres: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 40,
    align: "center",
  },

  {
    title: "Mã sản phẩm",
    dataIndex: "thuocId",
    key: "thuocId",
    align: "center",
    type: AUTO_COMPLETE,
    width: 100,
  },
  {
    title: "Tên sản phẩm",
    dataIndex: "tenThuoc",
    key: "tenThuoc",
    type: AUTO_COMPLETE,
    autoFocus: true,
    // rules: [{required: true, message: "Chưa nhập tên sản phẩm"}],
  },

  {
    title: "Đơn vị kê",
    dataIndex: "donViTinh",
    key: "donViTinh",
    align: "center",
    type: INPUT,
    disabled: true,
  },
  {
    title: "Số lượng kê",
    dataIndex: "soLuong",
    key: "soLuong",
    type: NUMBER,
    align: "right",
    disabled: true,
  },

  {
    title: "Liều dùng",
    dataIndex: "lieuDung",
    key: "lieuDung",
    type: INPUT,
    disabled: true,
  },
  {
    title: "Ghi chú của BS",
    dataIndex: "ghiChu",
    key: "ghiChu",
    type: INPUT,
    disabled: true,
  },

  // {
  //   title: "",
  //   dataIndex: "",
  //   key: "action",
  //   align: "center",
  //   width: 60,
  //   fixed: "right" as any,
  // },
];
const columnsSale: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 40,
    align: "center",
    show: true,
  },
  {
    title: "Số lô",
    dataIndex: "soLo",
    key: "soLo",
    type: AUTO_COMPLETE,
    width: 220,
    show: true,
  },
  {
    title: "",
    dataIndex: "id",
    key: "id",
    width: 0,
    type: INPUT,
    hidden: true,
    show: true,
  },
  {
    title: "Mã sản phẩm",
    dataIndex: "thuocId",
    key: "thuocId",
    type: AUTO_COMPLETE,
    width: 100,
    show: true,
  },
  {
    title: "Tên sản phẩm",
    dataIndex: "tenThuoc",
    key: "tenThuoc",
    type: AUTO_COMPLETE,
    width: 180,
    show: true,
    // rules: [{required: true, message: "Chưa nhập tên sản phẩm"}],
  },
  {
    title: "Hạn sử dụng",
    dataIndex: "hanSuDung",
    key: "hanSuDung",
    type: DATE,
    width: 120,
    show: true,
  },
  {
    title: "Giá nhập",
    dataIndex: "donGiaNhap",
    key: "donGiaNhap",
    type: CURRENCY,
    width: 130,
    show: true,
  },
  // {
  //   title: "Đơn vị kê",
  //   dataIndex: "donViKe",
  //   key: "donViKe",
  //   type: INPUT,
  //   disabled: true,
  // },
  // {
  //   title: "Số lượng kê",
  //   dataIndex: "soLuong",
  //   key: "soLuong",
  //   type: NUMBER,
  //   disabled: true,
  // },
  {
    title: "SL tồn kho",
    dataIndex: "tonKho",
    key: "tonKho",
    type: NUMBER,
    disabled: true,
    width: 80,
    show: true,
    align: "right",
  },

  {
    title: "SL bán",
    dataIndex: "soLuongBan",
    key: "soLuongBan",
    type: NUMBER,
    width: 80,
    show: true,
    align: "right",
  },
  {
    title: "SL hoàn trả",
    dataIndex: "soLuongHoanTra",
    key: "soLuongHoanTra",
    type: NUMBER,
    width: 80,
    show: true,
    align: "right",
  },
  {
    title: "Đơn vị bán",
    dataIndex: "donViBanId",
    key: "donViBanId",
    type: COMBO_BOX,
    width: 80,
    show: true,
  },
  {
    title: "",
    dataIndex: "donViBan",
    key: "donViBan",
    type: INPUT,
    width: 0,
    hidden: true,
    show: true,
  },
  {
    title: "Đơn giá",
    dataIndex: "donGia",
    key: "donGia",
    type: CURRENCY,
    width: 130,
    show: true,
  },
  {
    title: "VAT",
    dataIndex: "vat",
    key: "vat",
    type: NUMBER,
    addonAfter: "%",
    width: 80,
    show: true,
  },
  {
    title: "Thành tiền",
    dataIndex: "tongTien",
    key: "tongTien",
    type: CURRENCY,
    width: 140,
    disabled: true,
    show: true,
  },
  {
    title: "Thành tiền hoàn trả",
    dataIndex: "tongTienHoanTra",
    key: "tongTienHoanTra",
    type: CURRENCY,
    width: 140,
    disabled: true,
    show: true,
  },

  {
    title: "Liều dùng",
    dataIndex: "lieuDung",
    key: "lieuDung",
    type: INPUT,
    width: 120,
    show: true,
  },
  {
    title: "Ghi chú của BS",
    dataIndex: "ghiChu",
    key: "ghiChu",
    type: INPUT,
    width: 180,
    show: true,
  },
  // {
  //   title: "Số ĐK",
  //   dataIndex: "soDangKy",
  //   key: "soDangKy",
  //   type: INPUT,
  //   disabled: true,
  // },
  // {
  //   title: "Nước SX",
  //   dataIndex: "nuocSanXuat",
  //   key: "nuocSanXuat",
  //   type: INPUT,
  //   disabled: true,
  // },
  // {
  //   title: "Nhà cung cấp",
  //   dataIndex: "nhaCungCap",
  //   key: "nhaCungCap",
  //   type: INPUT,
  //   disabled: true,
  // },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];

const field: any[] = [
  {key: "", dataIndex: "", label: "", name: ""},
  {key: "", dataIndex: "", label: "", name: ""},
];
export {columnsSale, columnsPres};
